import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContratoDetailDto } from '@models/contrato/contratoDetailDto.model';
import { ContratosService } from '@services/contratos/contratos.service';
import { HistoricosPeriodoContratoService } from '@services/historicos-periodos-contrato/historicos-periodo-contrato.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { ListadoComprobantesGenericosComponent } from '@views/comprobantes/listado-comprobantes-genericos/listado-comprobantes-genericos.component';

@Component({
  selector: 'app-movimientos-contrato',
  templateUrl: './movimientos-contrato.component.html',
  styleUrls: ['./movimientos-contrato.component.css']
})
export class MovimientosContratoComponent implements OnInit {

  @ViewChild(ListadoComprobantesGenericosComponent) listadoComprobantesComponentChild!: ListadoComprobantesGenericosComponent
  idContrato!: number;
  contratoDetailDto: ContratoDetailDto = new ContratoDetailDto;

  constructor(
    public dialog: MatDialog,
    public historicosPeriodoContratoService: HistoricosPeriodoContratoService,
    private aRoute: ActivatedRoute,
    private contratoService: ContratosService,
    private spinner: NgxSpinnerService,
    private snackBar: SnackBarService,
  ) {
  }

  ngOnInit(): void {
    const routeParams = this.aRoute.snapshot.paramMap;
    this.idContrato = Number(routeParams.get('id'));
    if (this.contratoService.getContratoDto() != null) {
      this.contratoDetailDto = this.contratoService.getContratoDto()
    }
    else
      this.getContratoById(this.idContrato)
  }

  ngAfterViewInit() {
  }



  getContratoById(idContrato: number) {
    this.spinner.show("spContrato");
    this.contratoService.getById(idContrato).subscribe(
      data => {
        this.spinner.hide("spContrato");
        this.contratoDetailDto = data
        this.contratoService.setContratoDto(data);

      },
      error => {
        this.spinner.hide("spContrato");
        this.snackBar.showError(error, "Error");
      }
    )
  }


}
